import { map } from 'rxjs';
import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { PermissionsService } from './permissions.service';
import { PermissionTokens } from './auth.types';

export const ifHasRoleGuard = (tokens: PermissionTokens): CanActivateFn => () => {
  const permissions = inject(PermissionsService);
  const router = inject(Router);
  return permissions.isSufficient(tokens).pipe(
    map(has => has || router.createUrlTree([ '/', 'not-authorized' ])),
  );
};
